import {
  BACKUP_REGISTRATION_DATA,
  GET_MARKETABLE_PREFERENCE,
  REGISTER_CLEAR_USERNAME_SUGGESTIONS,
  REGISTER_FORM_VALIDATIONS,
  REGISTER_NEW_USER,
  REGISTER_SET_COUNTRY_CODE,
  REGISTER_SET_EMAIL_SUGGESTIONS,
  REGISTER_SET_USER_PIPELINE_DATA_LOADED,
  REGISTER_RESET_SUBMIT_STATE,
  REGISTRATION_CLEAR_BACKEND_ERROR,
  UPDATE_MARKETABLE_PREFERENCE,
} from './actions';
import {
  COMPLETE_STATE,
  DEFAULT_STATE,
  PENDING_STATE,
} from '../../data/constants';

export const storeName = 'register';

export const defaultState = {
  backendCountryCode: '',
  registrationError: {},
  registrationResult: {},
  marketablePreference: {
    isLoading: false,
    isMarketable: false,
  },
  registrationFormData: {
    configurableFormFields: {
      marketingEmailsOptIn: false,
    },
    formFields: {
      name: '',
      full_name: '',
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      password: '',
      confirm_password: '',
      terms_of_service: false,
      marketing_emails_opt_in: false,
    },
    additionalUserInformation: {
      level_of_education: '',
      academic_degree: '',
      city: '',
      country: '',
      gender: '',
      year_of_birth: '',
    },
    emailSuggestion: {
      suggestion: '', type: '',
    },
    errors: {
      name: '',
      first_name: '',
      last_name: '',
      full_name: '',
      email: '',
      username: '',
      password: '',
      confirm_password: '',
      terms_of_service: '',
    },
  },
  validations: null,
  submitState: DEFAULT_STATE,
  userPipelineDataLoaded: false,
  usernameSuggestions: [],
  validationApiRateLimited: false,
  shouldBackupState: false,
};

const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case BACKUP_REGISTRATION_DATA.BASE:
      return {
        ...state,
        shouldBackupState: true,
      };
    case BACKUP_REGISTRATION_DATA.BEGIN:
      return {
        ...defaultState,
        usernameSuggestions: state.usernameSuggestions,
        registrationFormData: { ...action.payload },
        userPipelineDataLoaded: state.userPipelineDataLoaded,
      };
    case REGISTER_NEW_USER.BEGIN:
      return {
        ...state,
        submitState: PENDING_STATE,
        registrationError: {},
      };
    case REGISTER_NEW_USER.SUCCESS: {
      return {
        ...state,
        registrationResult: action.payload,
        submitState: COMPLETE_STATE,
      };
    }
    case REGISTER_NEW_USER.FAILURE: {
      const { usernameSuggestions } = action.payload;
      return {
        ...state,
        registrationError: { ...action.payload },
        submitState: DEFAULT_STATE,
        validations: null,
        usernameSuggestions: usernameSuggestions || state.usernameSuggestions,
      };
    }
    case REGISTRATION_CLEAR_BACKEND_ERROR: {
      const registrationErrorTemp = state.registrationError;
      delete registrationErrorTemp[action.payload];
      return {
        ...state,
        registrationError: { ...registrationErrorTemp },
      };
    }
    case REGISTER_FORM_VALIDATIONS.SUCCESS: {
      const { usernameSuggestions, ...validationWithoutUsernameSuggestions } = action.payload.validations;
      return {
        ...state,
        validations: validationWithoutUsernameSuggestions,
        usernameSuggestions: usernameSuggestions || state.usernameSuggestions,
      };
    }
    case REGISTER_FORM_VALIDATIONS.FAILURE:
      return {
        ...state,
        validationApiRateLimited: true,
        validations: null,
      };
    case REGISTER_CLEAR_USERNAME_SUGGESTIONS:
      return {
        ...state,
        usernameSuggestions: [],
      };
    case REGISTER_SET_COUNTRY_CODE: {
      const { countryCode } = action.payload;
      if (!state.registrationFormData.configurableFormFields.country) {
        return {
          ...state,
          backendCountryCode: countryCode,
        };
      }
      return state;
    }
    case REGISTER_SET_USER_PIPELINE_DATA_LOADED: {
      const { value } = action.payload;
      return {
        ...state,
        userPipelineDataLoaded: value,
      };
    }
    case REGISTER_SET_EMAIL_SUGGESTIONS: {
      return {
        ...state,
        registrationFormData: {
          ...state.registrationFormData,
          emailSuggestion: action.payload.emailSuggestion,
        },
      };
    }
    case GET_MARKETABLE_PREFERENCE.BEGIN: {
      return {
        ...state,
        marketablePreference: {
          ...state.marketablePreference,
          isLoading: true,
        },
      };
    }
    case GET_MARKETABLE_PREFERENCE.SUCCESS: {
      return {
        ...state,
        marketablePreference: {
          isLoading: false,
          isMarketable: action.payload,
        },
      };
    }
    case GET_MARKETABLE_PREFERENCE.FAILURE: {
      return {
        ...state,
        marketablePreference: {
          ...state.marketablePreference,
          isLoading: false,
        },
      };
    }
    case UPDATE_MARKETABLE_PREFERENCE.BEGIN: {
      return {
        ...state,
        marketablePreference: {
          isLoading: true,
          isMarketable: action.payload,
        },
      };
    }
    case UPDATE_MARKETABLE_PREFERENCE.SUCCESS: {
      return {
        ...state,
        marketablePreference: {
          ...state.marketablePreference,
          isLoading: false,
        },
      };
    }
    case UPDATE_MARKETABLE_PREFERENCE.FAILURE: {
      return {
        ...state,
        marketablePreference: {
          isMarketable: !state.marketablePreference.isMarketable,
          isLoading: false,
        },
      };
    }
    case REGISTER_RESET_SUBMIT_STATE:
      return {
        ...state,
        submitState: DEFAULT_STATE,
      };
    default:
      return {
        ...state,
        shouldBackupState: false,
      };
  }
};

export default reducer;
